import logo from './logo.svg';
import './App.css';

import Nav from "./comp/nav";

import Home from "./comp/Home";

import Projects from "./comp/Projects";

import Certificates from "./comp/certificates";

import Skills from "./comp/skills";
import About from "./comp/About";
import Contact from "./comp/Contact";

import ScrollAnimation from 'react-animate-on-scroll';
import {Route,Routes} from 'react-router-dom';
function App() {
  return (
    <div className="App">
<Nav />


<Routes>
<Route path="/" element={<Home/>}/>

<Route path="/projects" element={<Projects/>}/>

<Route path="/certificates" element={<Certificates/>}/>

<Route path="/skills" element={<Skills/>}/>

<Route path="/about" element={<About/>}/>

<Route path="/contact" element={<Contact/>}/>



</Routes>


    </div>
  );
}

export default App;
